// Backend converts a 409 on any document/condition upload-or-attach step into
// an explicit `status: "retry"` response instead of a raw error, so the
// frontend never needs to infer retry state from status codes/error strings.

export const isRetryResponse = (payload) => payload?.status === "retry";

export const isRetryItem = (item) => item?.status === "retry";

// Some flows chain several awaited steps inside one try/catch, each already
// showing the DOCUMENT_RETRY_PENDING popup itself before bailing out. Throwing
// this marks the error as "already surfaced to the user" so the outer catch's
// generic error popup doesn't double up on top of it.
export const createRetryHandledError = () =>
	Object.assign(new Error("DOCUMENT_RETRY_PENDING"), { isRetryHandled: true });

export const isRetryHandledError = (error) => Boolean(error?.isRetryHandled);
